'use client';

import { useSearchParams } from 'next/navigation';
import { FC } from 'react';
import { BannerTileStoryblok } from 'storyblok-types';
import { IConfig } from 'pages/StoryBlok/TileBanner/types';
import { IYoutube, useYoutubeData } from 'modules/media/hooks';
import { MediaQuery } from 'modules/mui/hooks';
import { useStoryBlokBannerTileMediaQuery } from 'modules/mui/hooks';
import { DefaultTileContainer } from './DefaultTile';
import { YoutubeTile } from './components/YoutubeTile';
import { getTileBannerConfig } from './utils';

export const TileBanner: FC<{
  blok: BannerTileStoryblok;
  config?: IConfig | null;
  videoData: IYoutube | null;
  deviceType?: MediaQuery['type'];
}> = ({ config, blok, deviceType = 'mobile', videoData }) => {
  if (!config) {
    return null;
  }

  if (blok.type === 'video') {
    return <YoutubeTile blok={blok} videoData={videoData} config={config} />;
  }

  return (
    <DefaultTileContainer deviceType={deviceType} blok={blok} config={config} />
  );
};

export const TileBannerContainer: FC<{
  blok: BannerTileStoryblok;
  className?: string;
}> = ({ blok, className }) => {
  const deviceType = useStoryBlokBannerTileMediaQuery();
  const searchParams = useSearchParams();
  const videoData = useYoutubeData(blok?.youtubeLink);
  const config = getTileBannerConfig({
    blok,
    className,
    searchParams,
    deviceType,
  });

  return (
    <TileBanner
      blok={blok}
      config={config}
      videoData={videoData}
      deviceType={deviceType.type}
    />
  );
};
